module.exports = __webpack_public_path__ + "static/media/referal-image-3.82026144.png";